"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearFieldsPlugin = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const FieldPicker_1 = __importDefault(require("../../pickers/FieldPicker"));
const StyledConfiguratorDiv = styled_components_1.default.div `
  .MuiFormControlLabel-root {
    width: 100%;
  }
`;
const ClearFieldsConfigurator = props => {
    const { taskTypeId, onChange } = props;
    const [invoke, setInvoke] = (0, react_1.useState)(props.invoke);
    const [updateIndex, setUpdateIndex] = (0, react_1.useState)(-1);
    const [removeIndex, setRemoveIndex] = (0, react_1.useState)(-1);
    const [openSaveDialog, setOpenSaveDialog] = (0, react_1.useState)(false);
    if (!invoke.data)
        invoke.data = { items: [] };
    const data = invoke.data;
    if (!data.items)
        data.items = [];
    const { items } = data;
    const updateItem = items[updateIndex];
    const removeItem = items[removeIndex];
    const getDisplayFields = (item) => {
        const labels = item.fields.map(field => field.label);
        const i = labels.length > 3
            ? labels.slice(0, 2).concat(`${labels.length - 2} more fields`)
            : labels;
        const items = i.length < 3 ? i : [i.slice(0, -1).join(', ') + ',', ...i.slice(-1)];
        return items.join(' and ');
    };
    const update = (updatedData = data) => {
        const updatedInvoke = Object.assign(Object.assign({}, invoke), { data: updatedData });
        setInvoke(updatedInvoke);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedInvoke);
    };
    return (react_1.default.createElement(StyledConfiguratorDiv, null,
        react_1.default.createElement(core_1.Typography, { variant: 'body1' },
            "These items will appear as ",
            react_1.default.createElement("strong", null, "checkbox options"),
            " when prompted to clear fields."),
        react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, null, "Label"),
                        react_1.default.createElement(core_1.TableCell, null, "Fields"),
                        react_1.default.createElement(core_1.TableCell, null))),
                react_1.default.createElement(core_1.TableBody, null,
                    items.length === 0 && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 3 }, "No clear field items."))),
                    items.map((item, index) => (react_1.default.createElement(core_1.TableRow, { hover: true, key: `${item.label}-${index}`, onClick: () => {
                            setUpdateIndex(index);
                            setOpenSaveDialog(true);
                        } },
                        react_1.default.createElement(core_ui_1.WrappedTableCell, null, item.label),
                        react_1.default.createElement(core_ui_1.WrappedTableCell, null, getDisplayFields(item)),
                        react_1.default.createElement(core_1.TableCell, { padding: 'checkbox' },
                            react_1.default.createElement(core_1.IconButton, { onClick: event => {
                                    event.stopPropagation();
                                    setRemoveIndex(index);
                                } },
                                react_1.default.createElement(icons_1.Close, null))))))))),
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(core_1.Button, { variant: 'outlined', startIcon: react_1.default.createElement(icons_1.Add, null), onClick: () => setOpenSaveDialog(true) }, "Add Item")),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { open: !!removeItem && removeIndex > -1, title: 'Remove User', message: `Are you sure you want to remove item ${(removeItem === null || removeItem === void 0 ? void 0 : removeItem.label) || '?'}?`, confirmLabel: 'Remove', onCancel: () => setRemoveIndex(-1), onConfirm: () => {
                setRemoveIndex(-1);
                if (removeIndex > -1) {
                    items.splice(removeIndex, 1);
                    update();
                }
            } }),
        react_1.default.createElement(ClearFieldsSaveDialog, { item: updateItem, open: openSaveDialog, taskTypeId: taskTypeId, onCancel: () => {
                setOpenSaveDialog(false);
                setUpdateIndex(-1);
            }, onSave: item => {
                setOpenSaveDialog(false);
                setUpdateIndex(-1);
                if (updateIndex > -1) {
                    items.splice(updateIndex, 1, item);
                }
                else {
                    items.push(item);
                }
                update();
            } })));
};
const ClearFieldsSaveDialog = props => {
    const { open, taskTypeId, item: itemProp, onCancel, onSave } = props;
    const [item, setItem] = (0, react_1.useState)(() => itemProp || { label: '', fields: [] });
    const action = itemProp ? 'Update' : 'Add';
    const isValid = !!item.label && item.fields.length > 0;
    const handleSubmit = () => {
        if (isValid) {
            onSave === null || onSave === void 0 ? void 0 : onSave(item);
        }
    };
    // clear state
    (0, react_1.useEffect)(() => {
        !open && setItem({ label: '', fields: [] });
    }, [open]);
    (0, react_1.useEffect)(() => {
        open && itemProp && setItem(itemProp);
    }, [open, itemProp]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: open, maxWidth: 'sm', PaperProps: {
            component: 'form',
            onSubmit: event => {
                event.preventDefault();
                handleSubmit();
            }
        }, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null,
            action,
            " Clear Item"),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.DialogContentText, null, "Select fields to clear for this item"),
            react_1.default.createElement(core_1.Box, null,
                react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Item Name', value: item.label, onChange: event => {
                        setItem(item => (Object.assign(Object.assign({}, item), { label: event.target.value })));
                    } })),
            react_1.default.createElement(core_1.Box, null,
                react_1.default.createElement(FieldPicker_1.default, { hideCustomFields: true, taskTypeId: taskTypeId, value: item.fields.map(field => field.value), onChange: fields => setItem(item => (Object.assign(Object.assign({}, item), { fields }))) }))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
            react_1.default.createElement(core_1.Button, { type: 'submit', color: 'primary', variant: 'contained', disabled: !isValid, onClick: handleSubmit },
                action,
                " Item"))));
};
const ClearFieldsDisplay = () => null;
const ClearFieldsDialog = props => {
    const { open, data, onCancel, onSubmit } = props;
    const [skip, setSkip] = (0, react_1.useState)(false);
    const [selected, setSelected] = (0, react_1.useState)([]);
    const items = data.items || [];
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, "Clear Fields"),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.DialogContentText, null, "Select from the options below to clear fields."),
            react_1.default.createElement(core_1.FormControlLabel, { label: 'Skip Clear Fields', style: { paddingLeft: 8 }, control: react_1.default.createElement(core_1.Checkbox, { name: 'toggle', color: 'primary', checked: skip, onChange: () => {
                        setSkip(skip => !skip);
                        setSelected([]);
                    } }) }),
            react_1.default.createElement(core_1.Divider, null),
            react_1.default.createElement(core_1.FormGroup, { style: { paddingLeft: 8 } },
                items.length === 0 && (react_1.default.createElement(core_1.Box, { my: 2 },
                    react_1.default.createElement(core_1.Typography, { variant: 'body1' }, "There are no configured items."))),
                items.map((item, index) => {
                    const isSelected = selected.includes(item.label);
                    return (react_1.default.createElement(core_1.FormControlLabel, { disabled: skip, label: item.label, key: `${item.label}-${index}`, control: react_1.default.createElement(core_1.Checkbox, { color: 'primary', checked: isSelected, onChange: () => {
                                setSelected(selected => {
                                    return isSelected
                                        ? selected.filter(i => i !== item.label)
                                        : selected.concat(item.label);
                                });
                            } }) }));
                }))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: !skip && selected.length === 0, onClick: () => onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(selected) },
                skip && 'Skip ',
                "Clear Fields"))));
};
exports.ClearFieldsPlugin = {
    src: 'clearFields',
    name: 'Clear Fields',
    configurator: ClearFieldsConfigurator,
    display: ClearFieldsDisplay,
    validate: condition => {
        const data = condition.data;
        return !!(data &&
            Array.isArray(data.items) &&
            data.items.length > 0 &&
            data.items.every(item => item.label && item.fields.length > 0));
    },
    service: (state, params, render) => {
        if (!render) {
            return false;
        }
        console.log('clearFields params', params);
        const pluginParams = Array.isArray(params) ? params[0] : params;
        return new Promise((resolve, reject) => {
            render(react_1.default.createElement(ClearFieldsDialog, { open: true, data: pluginParams.data, onCancel: () => {
                    render(undefined);
                    reject();
                }, onSubmit: labels => {
                    state.context.clearFieldItems = labels;
                    render(undefined);
                    resolve(true);
                } }));
        });
    }
};
//# sourceMappingURL=ClearFieldsPlugin.js.map